module.exports = __webpack_public_path__ + "img/container-4-v.73f18e45.png";